import clientInfo from 'common/lib/clientInfo';
import { useCallback } from 'react';
import { trackProductAnalytics } from 'common/services/product_analytics';
import { useResultContext } from 'common/components/CopyMagic/contexts';

const useTrackOnApply = () => {
  const { isEdited, result } = useResultContext();
  const contentId = result?.id;
  const modelName = result?.meta?.modelName;

  const trackCallback = useCallback(() => {
    trackProductAnalytics('Course Outline Generator Apply Clicked', {
      'Site ID': clientInfo.get('site_id'),
      'Is Edited': isEdited(),
      'Content ID': contentId,
      'Course Outline Model Used': modelName,
    });
  }, [isEdited, contentId, modelName]);

  return trackCallback;
};

export default useTrackOnApply;
